var map = {
	"./culturebox.png": 642,
	"./france-2.png": 643,
	"./france-3.png": 644,
	"./france-4.png": 645,
	"./france-5.png": 646,
	"./france-tv.png": 647,
	"./franceinfo.png": 648,
	"./okoo.png": 649,
	"./slash.png": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 641;